import { useMutation, useQueryClient } from '@tanstack/react-query';

import { actionItemCommentsKey } from '@pages/ActionItem/services/useActionItemCommentsQuery';

import { actionItemActiveReportKey } from '@services/actionItem/useActionItemActiveReportQuery';
import { actionItemInactiveReportsKey } from '@services/actionItem/useActionItemInactiveReportsQuery';
import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

const saveNewWwReportFn = (data) => apiClient.post(`${APP_API_URL}save-new-ww-report`, data);

export const useSaveNewWwReportMutation = ({ actionItemId }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveNewWwReportFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemActiveReportKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: actionItemInactiveReportsKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
    },
  });
};
